export const action_items_icon =
	'https://reelay-ai-production.s3.us-west-1.amazonaws.com/assets/images/action_items_icon.png';

export const terms_icon =
	'https://reelay-ai-production.s3.us-west-1.amazonaws.com/assets/images/terms_icon.png';

export const transcript_icon =
	'https://reelay-ai-production.s3.us-west-1.amazonaws.com/assets/images/noun-transcript-5456050+(1).svg';
